import { ColDef } from 'ag-grid-community';

const channelOrderingColumnDefs: ColDef[] = [
    {
        colId: 'channel-order-drag-col',
        headerName: '',
        width: 40,
        rowDrag: true,
        cellRenderer: 'agRowDragCellRenderer',
        suppressHeaderMenuButton: true,
        sortable: false,
        menuTabs: [],
    },
    {
        colId: 'channel-order-name-col',
        headerName: 'Channel name',
        field: 'name',
        width: 360,
        menuTabs: [],
    },
    {
        colId: 'channel-order-owner-col',
        headerName: 'Owner',
        field: 'owner.name',
        width: 280,
        menuTabs: [],
    },
];

export default channelOrderingColumnDefs;
